import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dda91d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-content" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-gap" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ganti-button",
  style: {"cursor":"pointer"}
}, "Change Profile Photo", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sep" }, null, -1))
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "card-body-content" }
const _hoisted_10 = { class: "card-body-text" }
const _hoisted_11 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "artist-pic",
            style: _normalizeStyle({ backgroundImage: `url( ${ _ctx.artist!.photo_url || require('@/assets/img/photo-placeholder.png')})`})
          }, null, 4),
          _createElementVNode("label", null, [
            _createElementVNode("input", {
              type: "file",
              style: {"display":"none"},
              accept: "image/*",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args))),
              id: "profile-image"
            }, null, 32),
            _hoisted_6
          ]),
          (_ctx.has_changed)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "reset-button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
              }, "Reset"))
            : _createCommentVNode("", true)
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_n_form, {
                ref: "formRef",
                model: _ctx.artist,
                rules: _ctx.rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_form_item, {
                    id: "artist-email-form",
                    path: "artist.user.email",
                    label: "Email",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        id: "user-email",
                        value: _ctx.artist!.user.email,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.artist!.user.email) = $event)),
                        onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                        size: "large",
                        disabled: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_n_form_item, {
                    id: "artist-fullname-form",
                    path: "user.fullname",
                    label: "Full Name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        id: "service_name",
                        value: _ctx.artist!.user.full_name,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.artist!.user.full_name) = $event)),
                        onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                        size: "large",
                        placeholder: "Enter your full name"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_n_form_item, {
                    id: "artist-username-form",
                    path: "artist.user.username",
                    label: "Username"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        id: "username",
                        value: _ctx.artist!.user.username,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.artist!.user.username) = $event)),
                        onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                        size: "large",
                        placeholder: "Enter your username",
                        style: {}
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_n_form_item, {
                    id: "artist-categories-form",
                    path: "artist.categories",
                    label: "Category"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_select, {
                        id: "categories",
                        value: _ctx.artist!.categories,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.artist!.categories) = $event)),
                        multiple: "",
                        clearable: "",
                        filterable: "",
                        remote: "",
                        size: "large",
                        onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                        options: _ctx.categoryOptions,
                        onSearch: _ctx.categorySearch
                      }, null, 8, ["value", "options", "onSearch"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_n_form_item, {
                    id: "artist-cities-form",
                    path: "artist.cities",
                    label: "City"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_select, {
                        id: "cities",
                        value: _ctx.artist!.cities,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.artist!.cities) = $event)),
                        multiple: "",
                        clearable: "",
                        filterable: "",
                        remote: "",
                        size: "large",
                        onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                        options: _ctx.cityOptions,
                        onSearch: _ctx.citySearch
                      }, null, 8, ["value", "options", "onSearch"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_n_form_item, {
                    id: "artist-description-form",
                    path: "user.description",
                    label: "Description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        value: _ctx.artist!.user.description,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.artist!.user.description) = $event)),
                        placeholder: "Tell us about yourself. How long have you been working? What kind of work do you usually do? Etc.",
                        type: "textarea",
                        autosize: {
                      minRows: 3,
                      maxRows: 5
                    }
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_n_form_item, {
                    id: "artist-address-form",
                    path: "address",
                    label: "Address"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        id: "address",
                        value: _ctx.artist!.address,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.artist!.address) = $event)),
                        type: "textarea",
                        onKeydown: _cache[14] || (_cache[14] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                        placeholder: "Enter your address",
                        autosize: {
                        minRows: 2,
                        maxRows: 5
                      }
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_n_form_item, {
                    id: "artist-phone_number-form",
                    path: "artist.phone_number",
                    label: "Phone number"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        id: "phone_number",
                        value: _ctx.artist!.phone_number,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.artist!.phone_number) = $event)),
                        onKeydown: _cache[16] || (_cache[16] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                        placeholder: "Enter your phone number"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  (_ctx.artist!.status)
                    ? (_openBlock(), _createBlock(_component_n_form_item, {
                        key: 0,
                        id: "artist-website",
                        path: "artist.website",
                        label: "Artist Website"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_input, {
                            id: "website",
                            value: _ctx.artist!.website,
                            "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.artist!.website) = $event)),
                            onKeydown: _cache[18] || (_cache[18] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                            placeholder: "Enter the URL/link to your online portfolio, for example Instagram or YouTube. Potential clients can look at your other works."
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.artist!.status)
                    ? (_openBlock(), _createBlock(_component_n_form_item, {
                        key: 1,
                        id: "artist-portfolioUrlRegForm",
                        path: "artist.portfolio_url_reg",
                        label: "Portfolio URL for Registration"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_input, {
                            id: "portfolio_url_reg",
                            value: _ctx.artist!.portfolio_url_reg,
                            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.artist!.portfolio_url_reg) = $event)),
                            onKeydown: _cache[20] || (_cache[20] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                            size: "small",
                            type: "textarea",
                            placeholder: "Enter the URL or link to your online portfolio, for example Instagram or YouTube. This will be used to verify your account."
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "brand",
                id: "kembali-button",
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
              }, "Cancel"),
              _createVNode(_component_n_button, {
                id: "simpan-button",
                loading: _ctx.submitLoading,
                onClick: _ctx.call,
                "icon-placement": "left",
                "attr-type": "submit",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Update ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ])
        ])
      ])
    ])
  ]))
}